import orm from 'models/orm'
import { Fields } from 'models/User'
import { createSelector as createOrmSelector } from 'redux-orm'

export const selectUsers = createOrmSelector(
  orm,
  (state: any) => state.orm,
  (session: any): Fields[] => {
    return session.User.all().toRefArray()
  }
)
